import { render } from "./Wikipedia.vue?vue&type=template&id=c375a6b6"
import script from "./Wikipedia.vue?vue&type=script&lang=js"
export * from "./Wikipedia.vue?vue&type=script&lang=js"

import "./Wikipedia.vue?vue&type=style&index=0&id=c375a6b6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__